import { useDeviceType } from '@cian/ui-kit';

import { useApplicationContext } from '../utils/applicationContext';
import { getNewbuildingListingUrl } from '../utils/urls';

export const useNewbuildingListingUrl = (newbuildingIds: number[]): string => {
  const deviceType = useDeviceType();
  const { config } = useApplicationContext();

  return getNewbuildingListingUrl(newbuildingIds, config, deviceType);
};
